import { useState } from "react";
import ButtonComponent from "../Button";
import AddItemDropdown from "./AddItemDropdown";
import { useErrorWebsocket } from "../../hooks/services";
import useUser from "../../hooks/context/userHook";
import useBoardAndItems from "../../hooks/context/useBoardAndItems";
import useFireNudgeTrigger from "../../hooks/api/useFireNudgeTrigger";
import { useBigAccount } from "../../hooks/ui";
import useMondayContext from "@hooks/context/useMondayContext";

interface AddItemButtonProps {
  centered: boolean;
  tourState: boolean;
}

const AddItemButton = ({ centered, tourState }: AddItemButtonProps) => {
  const { userId } = useUser();
  const { appFeatureType } = useMondayContext();
  const { currentBoard, itemIds } = useBoardAndItems();
  const fireNudge = useFireNudgeTrigger();
  const [open, setOpen] = useState(false);
  const bigAccount = useBigAccount();

  useErrorWebsocket(userId?.toString() || "");

  const handleShareClick = () => {
    // A2: "share item" clicked in an item view (target = this item)
    if (appFeatureType === "AppFeatureItemView") {
      fireNudge({
        source: "share_opened_item",
        itemid: itemIds?.[0],
        boardid: currentBoard,
        viewType: "item_view",
      });
    }
    setOpen(!open);
  };

  return (
    <div className="flex gap-3">
      <div className="relative">
        <ButtonComponent
          id="add_item_step1"
          className="add-item-button"
          relative
          text="Add to board"
          onClick={handleShareClick}
        />

        {open && (
          <AddItemDropdown
            centered={centered}
            setOpen={setOpen}
            fullWidth={false}
            bigAccount={bigAccount}
            stepsEnabled={tourState}
          />
        )}
      </div>
    </div>
  );
};

export default AddItemButton;
